import { bulk } from './update';
import addError from '../../../utils/error.jsx';

export function request(id, sport, displayOrder, displayFields) {
    return {
        type: 'COMPETITIONS_MOVE_REQUEST',
        displayOrder,
        sport,
        id,
        displayFields
    };
}

export function error(errors) {
    addError(errors);

    return {
        type: 'COMPETITIONS_MOVE_ERROR',
        errors
    };
}

export function finish(competitions) {
    return (dispatch) => {
        dispatch(bulk(competitions));

        dispatch({
            type: 'COMPETITIONS_MOVE_FINISH',
            competitions
        });
    };
}

export function clear() {
    return {
        type: 'COMPETITIONS_MOVE_CLEAR'
    };
}
